import TtamInterestsLabel from './label/index.vue';
import TtamInterestsTargetType from './target-type/index.vue';
import TtamInterestsInMarketCategory from './in-market-category/index.vue';
import TtamInterestsCommonInterestsCategory from './common-interests-category/index.vue';
import TtamInterestsLegalOfflineKeywordsAlert from './legal-offline-keywords-alert/index.vue';
import TtamInterestsOfflineKeywordsAlert from './offline-keywords-alert/index.vue';

import hooks from './hooks';

export default {
  TtamInterestsLabel,
  TtamInterestsTargetType,
  TtamInterestsInMarketCategory,
  TtamInterestsOfflineKeywordsAlert,
  TtamInterestsLegalOfflineKeywordsAlert,
  TtamInterestsCommonInterestsCategory,
  ...hooks,
};
